<template>
  <v-container
    id="task-check-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$task_check"
      color="accent"
      :title="page_title"
    >
      <v-card-title>
        <v-row class="ma-0">
          <v-spacer v-if="!$vuetify.breakpoint.mdAndDown" />
          <v-switch
            v-model="show_closed"
            class="mx-2"
            :label="$t('show_closed')"
          />
          <data-selector
            v-if="profile.can['training-edit-admin']"
            v-model="user_id"
            field-name="user"
            source-type="instructors"
            hide-details
            class="mx-2"
          />
          <v-text-field
            v-model="search"
            append-icon="$search"
            class="ml-auto"
            hide-details
            :label="$t('search_records')"
            single-line
            style="max-width: 400px;"
          />
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="computed_headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
        >
          <template #item.student="{item}">
            {{ item.instructor ? item.pic.name : item.sic.name }}
          </template>

          <template #item.time="{item}">
            {{ item.takeoff_time | timeFormat }} - {{ item.landing_time | timeFormat }}
          </template>

          <template #item.task="{item}">
            {{ item.user_training_task[0].training_task.idx }}
          </template>

          <template #item.comment="{item}">
            {{ item.user_training_task[0].pivot.comment }}
          </template>

          <template #item.instructor="{item}">
            {{ item.instructor ? item.instructor.name : item.pic.name }}
          </template>

          <template #item.actions="{item}">
            <span style="display: flex">
              <v-rating
                v-model="item.user_training_task[0].pivot.rating"
                class="pr-2"
                :readonly="item.user_training_task[0].pivot.success === 1 || checkEdit(item)"
                hover
                dense
                length="5"
                size="20"
              />
              <tooltip-btn
                v-if="!item.user_training_task[0].pivot.success && item.user_training_task[0].pivot.rating"
                :disabled="checkEdit(item)"
                color="edit"
                icon="$check"
                tooltip="i_certify"
                @click="clickSuccessFlight(item)"
              />
              <flight-informations
                :flight="item"
              />
            </span>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import FlightInformations from '@/layouts/default/infos/FlightInfo'
  import TooltipBtn from '@/components/TooltipBtn'

  export default {
    name: 'TaskCheck',
    components: {
      TooltipBtn,
      FlightInformations,
    },
    data () {
      return {
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        user_id: null,
        show_closed: false,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('userTraining/options'),
      search: sync('userTraining/search'),
      headers () {
        return [
          {
            text: this.$t('fields.student'),
            align: 'start',
            sortable: false,
            value: 'student',
          },
          {
            text: this.$t('fields.date'),
            align: 'start',
            sortable: false,
            value: 'date',
          },
          {
            text: this.$t('fields.time'),
            align: 'start',
            sortable: false,
            value: 'time',
          },
          {
            text: this.$t('fields.task'),
            sortable: false,
            value: 'task',
          },
          {
            text: this.$t('fields.comment'),
            sortable: false,
            value: 'comment',
          },
          {
            text: this.$t('fields.plane_regnum'),
            sortable: false,
            value: 'plane.reg_num',
          },
          {
            hide_small: true,
            text: this.$t('fields.instructor'),
            align: 'start',
            sortable: false,
            value: 'instructor',
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            width: '200px',
            align: 'right',
          },
        ]
      },
      page_title () { return this.$t('task_check') },
      editor () { return true },
      computed_headers () {
        return this.headers.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown)
      },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      show_closed: {
        handler () {
          this.load()
        },
        deep: true,
      },
      user_id: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.user_id = this.profile.user_id
    },
    methods: {
      getList: call('userTraining/search_task_check'),
      getFlightInfo: call('flightGeneral/info'),
      userTrainingSuccessFlight: call('userTrainingTask/userTrainingSuccessFlight'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            user_id: this.user_id,
            show_closed: this.show_closed,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      clickSuccessFlight (item) {
        this.userTrainingSuccessFlight({ id: item.user_training_task[0].id, flight_id: item.id, rating: item.user_training_task[0].pivot.rating }).then(response => {
          item.user_training_task[0].pivot.success = true
          // this.items.splice(this.items.indexOf(item), 1)
          this.load()
        })
      },
      checkEdit (item) {
        // const instructor_id = item.instructor_id ?? -1
        // console.log(item.pic_id != profile.user_id)
        return false // item.pic_id != profile.user_id // && instructor_id != profile.user_id
      },
      visibleFlightInfo (item) {
        return item.flight_id !== null
      },
    },
  }
</script>
